import useGlobalVariable from "@lib/store/hooks/useGlobalVariables";
import HTMLRender from "@src/components/core/HTMLRender";
import get from "lodash/get";
import CloseButton from "../CloseButton";
import styles from "./Modal.module.css";

const ResponseFormModal = ({ context, id, innerProps }) => {
  const { gv } = useGlobalVariable();
  const text = get(context, "modals.0.props.data.response");
  const type = get(context, "modals.0.props.type");
  console.log(gv("close"), gv);
  console.log("🚀 ~ file: ResponseFormModal.js ~ line 7 ~ ResponseFormModal ~ context", context);
  if (type === "SUCCESS") {
    // const message = get(context, "modals.0.props.data");
    // console.log
    return (
      <div className={`center overflow-hidden rounded-xl bg-white ${styles.responseModal}`}>
        <CloseButton closeText={gv("close")} onClick={() => context.closeModal(id)} />
        <HTMLRender data={text} />
        {/* <HTMLRender data={message} /> */}
      </div>
    );
  }
  return (
    <div className="center mt-6 overflow-hidden rounded-xl bg-white">
      <pre>{JSON.stringify({ context, id, innerProps }, null, 2)}</pre>
    </div>
  );
};

export default ResponseFormModal;
